import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'

import { appConfig } from '../app-config/AppConfig'
import { AUTH_LOGIN_PATH, AUTH_REFRESH_PATH } from '../constants'
import axiosInstance from '../lib/api/axiosInstance'
import globalStore from '../store'
import { ServerResponse } from '../types'
import { clearTokens, setAccessToken, setRefreshToken } from '../user'
import { UserPlatform } from '../user'

import { TokenResponse, TokensDataType } from './types'

class HandleTokenService {
  private config: AxiosRequestConfig = {
    method: 'POST',
    url: AUTH_LOGIN_PATH,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: {},
  }

  private refreshConfig: AxiosRequestConfig = {
    method: 'GET',
    url: AUTH_REFRESH_PATH,
    headers: {
      'Content-Type': 'application/json',
    },
  }

  removeAll = () => {
    globalStore.dispatch(clearTokens())
  }

  getAccessToken = () => {
    const state = globalStore.getState()
    return state.tokens.token
  }

  getRefreshToken = () => {
    const state = globalStore.getState()
    return state.tokens.refreshToken
  }

  setAccessAndRefreshToken = (accessToken: string, refreshToken: string) => {
    globalStore.dispatch(setAccessToken(accessToken))
    globalStore.dispatch(setRefreshToken(refreshToken))
  }

  refreshToken = (platform?: UserPlatform) => {
    const refreshToken = this.getRefreshToken()

    // token is not present, need to log in again
    if (!refreshToken) {
      return new Promise((resolve) => {
        resolve({})
      })
    }

    this.refreshConfig.headers = this.refreshConfig.headers || {}
    this.refreshConfig.headers['Authorization'] = `Bearer ${refreshToken}`
    this.refreshConfig.params = platform ? { platform } : undefined

    return axiosInstance(this.refreshConfig).then(
      ({ data: response }: AxiosResponse<ServerResponse<TokensDataType>>) => {
        axiosInstance.defaults.headers.common.Authorization = `Bearer ${response.data.accessToken}`
        this.setAccessAndRefreshToken(response.data.accessToken, response.data.refreshToken)

        return Promise.resolve(response)
      },
    )
  }

  retrieveTokenData = (email: string, password: string, platform: UserPlatform) => {
    const requestData = {
      email: email.toString(),
      password: password.toString(),
      platform,
    }

    this.config.data = JSON.stringify(requestData)
    this.config.headers = this.config.headers || {}
    this.config.headers['Content-Type'] = 'application/json'

    const noInterceptorInstance = axios.create({
      baseURL: appConfig.REACT_APP_API_URL,
      withCredentials: true,
    })

    return noInterceptorInstance(this.config).then((response: AxiosResponse) => {
      const { data }: TokenResponse = response.data
      axiosInstance.defaults.headers.common.Authorization = `Bearer ${data.accessToken}`
      this.setAccessAndRefreshToken(data.accessToken, data.refreshToken)

      return Promise.resolve(data)
    })
  }
}

const TokenService = new HandleTokenService()

export default TokenService
